module.exports = __webpack_public_path__ + "img/top-product-des.b96ebfaf.png";